/**
 * Company-flag checks for the Partial Sales wizard. The wizard receives
 * `company.feature_types` (the enabled flag names) from
 * SuccessionController#partial_sales_wizard.
 */
const hasFeature = (company, name) => Array.isArray(company?.feature_types) && company.feature_types.includes(name);

/**
 * RJ asked for the yellow guidance boxes on the Description, Review and Publish
 * steps (Documentation Requirements, Important Notes, Important Considerations)
 * to go. Other tenants keep them, so this is behind
 * `partial_sales_hide_listing_guidance` (feature 363), off by default.
 * See docs/plans/2026-11-02-fix-partial-sales-rj-ui-polish-batch-plan.md
 */
export const hidesListingGuidance = (company) => hasFeature(company, 'partial_sales_hide_listing_guidance');

export default hidesListingGuidance;
